const E = (e) => e && e.length ? e[e.length - 1] : void 0, ie = (e) => e && e.length ? e[0] : void 0;
function ue(e, t, n, ...r) {
  return [...e.slice(0, t), ...r, ...e.slice(t + n)];
}
function D(e) {
  return e.filter((t, n, r) => r.indexOf(t) === n);
}
const d = (e, t) => (n, ...r) => e(t(n, ...r)), w = /^([\d_]{2})([\d_]{3})([\d_]{3})([\d_]{4})([\d_]{2})$/g, A = "$1.$2.$3/$4-$5", _ = (e) => e.replace(w, A), de = (e = "") => _(
  e.replace(/\D/g, "").replace(/(\d{14})[\w\W]/, "$1").padStart(14, "_")
), y = (e, t) => {
  const n = e - 7 - t;
  return n < 2 ? n + 8 : n;
}, S = (e) => e.map((t, n, { length: r }) => t * y(r, n)).reduce((t, n) => t + n), k = (e) => e % 11 < 2 ? 0 : 11 - e % 11, F = d(k, S);
function le(e = "") {
  const t = e.replace(/\D/g, "").split("").map(Number);
  if (t.length !== 14 || D(t).length === 1)
    return !1;
  const n = t.filter((o, s) => s < 12), r = F(n), c = F([...n, r]);
  return [r, c].join("") === t.filter((o, s) => s >= 12).join("");
}
const v = /^([\d_]{3})([\d_]{3})([\d_]{3})([\d_]{2})$/g, M = "$1.$2.$3-$4", j = (e) => e.replace(v, M), pe = (e = "") => j(
  e.replace(/\D/g, "").replace(/(\d{11})[\w\W]/, "$1").padStart(11, "_")
), I = (e) => e.map((t, n, { length: r }) => t * (r + 1 - n)).reduce((t, n) => t + n), O = (e) => e % 11 < 2 ? 0 : 11 - e % 11, m = d(O, I), Fe = (e = "") => {
  const t = e.replace(/\D/g, "").split("").map(Number);
  if (t.length !== 11 || D(t).length === 1)
    return !1;
  const n = t.filter((o, s) => s < 9), r = m(n), c = m([...n, r]);
  return [r, c].join("") === t.filter((o, s) => s >= 9).join("");
}, h = (e = "") => /^3[47][0-9]+$/gi.test(e.replace(/\D+/g, "")), z = (e = "") => h(e) ? e.replace(/^(X*)([\dX]{4})([\dX]{6,})([\dX]{5})$/, "$2 $3 $4") : e.replace(/^([\dX]{4})([\dX]{4})([\dX]{4})([\dX]{4})([\d]*)$/, "$1 $2 $3 $4 $5").trim(), me = (e = "") => {
  const t = h(e);
  return z(
    e.replace(/\D/g, "").replace(/(\d{19})[\w\W]*/, "$1").padStart(t ? 15 : 16, "X")
  );
}, R = (e, t) => t % 2 !== 0 ? e * 2 : e, T = (e) => e > 9 ? e - 9 : e, P = (e) => (t) => e + t;
function fe(e = "") {
  const t = e.replace(/\D/g, "").split("").map(Number).reverse();
  return t.length < 13 || t.length > 19 || t.every((n, r, c) => n === c[0]) ? !1 : t.reduce(
    (n, r, c) => d(P(n), d(T, R))(
      r,
      c
    ),
    0
  ) % 10 === 0;
}
const $e = (e, t) => (n) => (r) => e({ ...t, [n]: r }), ge = (e = "") => e.replace(/(\d{4})-(\d{2})-(\d{2})[\w\W]*/, "$3/$2/$1"), W = (e = "") => e.replace(/([0-2-_][\d_]|3[0-1])([0_][\d_]|[1_][0-2_])([\d_]{4})/, "$1/$2/$3"), De = (e = "") => W(e.replace(/\D/g, "").replace(/(\d{8})[\w\W]/, "$1").padStart(8, "_")), l = (e) => e.replace("#", "").substring(0, 6).match(/.{2}/g).map((t) => parseInt(t, 16) / 255), N = (e) => e <= 0.03928 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function f(e, t, n) {
  const [r, c, o] = [e, t, n].map(N);
  return r * 0.2126 + c * 0.7152 + o * 0.0722;
}
function $(e, t) {
  const n = f(e[0], e[1], e[2]), r = f(t[0], t[1], t[2]), c = Math.max(n, r), o = Math.min(n, r);
  return (c + 0.05) / (o + 0.05);
}
const he = (e, t, n) => {
  const r = l(e), c = l(t), o = l(n), s = $(r, c), u = $(r, o);
  return s > u ? t : n;
}, xe = (e = {}, t = "", n = "") => {
  if (!t || !e) return e;
  const r = Array.isArray(t) ? t : t.toString().split(/[.[\]]+/), c = r.slice(0, -1).reduce((o, s, u) => (Object(o[s]) !== o[s] && (o[s] = Math.abs(r[u + 1]) >> 0 === +r[u + 1] ? [] : {}), o[s]), e);
  return c[E(r)] = n, e;
}, x = (e) => e.replace(/\D/g, "").padStart(4, "0"), Ce = (e = "") => x(e).replace(/\w*(\d\d)(\d\d)$/i, "$1:$2"), be = (e = "") => {
  const t = x(e).match(/\w*(\d\d)(\d\d)$/i), n = t[1], r = t[2];
  return Number(r) > 59 ? `${String(Number(n) + 1)}:${String(Number(r) - 60)}` : `${n}:${r}`;
}, X = (e = "") => e.replace(/^([\d_]{2})([\d_]{2,4})$/g, "$1/$2"), Ee = (e = "") => X(
  e.replace(/\D/g, "").replace(/(\d{6})[\w\W]/, "$1").padStart(6, "_")
), we = (e) => /^(0[1-9]|1[0-2])\/?(\d{2}|\d{4})$/g.test(e), Ae = (e = "") => e.replace(/^\?/, "").split("&").reduce((t, n) => {
  let [r, c] = n.split("=").map((o) => decodeURIComponent(o.replace(/\+/g, "%20")));
  return r.endsWith("[]") && (r = r.slice(0, -2), c = t[r] ? t[r].concat(c) : [c]), { ...t, ...c ? { [r]: c } : {} };
}, {}), _e = (e) => e, ye = (e = 0, t = "BRL", n = "pt-br") => Number(e).toLocaleString(n, {
  style: "currency",
  currency: t
}), Se = (e = "") => {
  const t = /[A-Z$\s]+/g, n = /,/g, s = String(e).replace(t, "").replace(n, ".").replace(/\.+(\d|$)/g, ".$1").replace(/\.(?=.*\.)/g, "");
  return Number(s);
}, g = /([\w]+)(\d{3})(\.?[\w]*)/g, C = (e, t = ".") => g.test(e) ? C(e.replace(g, `$1${t}$2$3`)) : e, U = (e = 0) => `R$ ${C(
  Number(e).toFixed(2).replace(".", ",")
)}`, ke = (e = "0") => U(
  e.replace(/\.(\d)$/, ".$10").replace(/\D/g, "").padStart(3, "0").replace(/([\d]*)(\d\d)/, "$1.$2")
), ve = (e = 0) => {
  String.prototype.padEnd || Object.defineProperty(String.prototype, "padEnd", {
    configurable: !0,
    writable: !0,
    /**
     * @param { Number } targetLength target string length
     * @param { String } padString string to pad to the end
     * @returns string padded on the end
     */
    value: function(a, i) {
      return a = a >> 0, i = String(typeof i < "u" ? i : " "), this.length > a ? String(this) : (a = a - this.length, a > i.length && (i += i.repeat(a / i.length)), String(this) + i.slice(0, a));
    }
  });
  const t = typeof e == "string" || e instanceof String ? e.replace(/^[^\d.,]*/g, "") : e.toFixed(4), n = t.split("").reduce((a, i) => i === "," ? { ...a, comma: a.comma + 1 } : i === "." ? { ...a, dot: a.dot + 1 } : a, { comma: 0, dot: 0 });
  if (n.comma > 1 && n.dot > 1)
    throw new Error("Invalid value");
  if (!t.match(/^\d?([.,\d]*)[\d.,]$/))
    throw new Error("Invalid value");
  const c = t.indexOf(","), s = t.indexOf(".") > c ? "." : ",", u = s === "." ? t.replace(/[,]/g, "") : t.replace(/[.]/g, "");
  return parseInt(
    (u + s).split(s).slice(0, 2).map(
      (a, i) => i ? a.padEnd(2, "0").substring(0, 2) : a
      // Keep integer part untouched
    ).join("")
    // Merge strings
  ) || 0;
}, L = (e) => {
  if (!b(e))
    return e;
  const t = e.replace(/[^\d]/g, "");
  return t.length === 9 || t.length === 11 ? t.replace(/(\d\d)?(\d)(\d{4})(\d{4})/, "($1) $2 $3-$4") : t.replace(/^0/, "").replace(/(\d\d(?=\d{8,}))?(\d{1,5})(\d{4})/, "($1) $2-$3");
}, V = (e) => L(e).replace(/^\s*(?:\(\))?\s*/g, "").replace(/\s{2,}/g, " "), B = (e = "") => V(String(e)), Me = (e = "") => B(
  e.replace(/\D/g, "").replace(/^0*/g, "").replace(/(\d{11})[\w\W]*/, "$1")
), je = (e = "") => e.replace(/\D/g, ""), b = (e = "") => {
  const t = String(e).replace(/[\s()-]/g, "").replace(/^0*/, "").length;
  return t >= 8 && t <= 11;
}, Ie = (e = "") => {
  const t = e[0] === "+" ? e : `+${e}`;
  if (t.startsWith("+55"))
    return b(t.replace(/^\+55/, ""));
  const n = t.replace(/\D/g, "").length;
  return n >= 6 && n <= 15;
}, H = /^([0-1][\d]|[2][0-3])(?:(\d{2}?)$)/g, Z = "$1:$2", q = (e) => e.replace(H, Z), Q = (e = "") => e.replace(/\D/g, "").padStart(4, "0"), J = (e = "") => /^([0-1][\d]|[2][0-3])(?:(\d{2}?)$)/g.test(e), K = (e = "") => {
  const t = Q(e);
  return J(t) ? q(t) : K(t.substring(1, e.length));
};
function Oe(e = "") {
  return /^([0-1]\d|2[0-3]):[0-5][0-9]$/g.test(e);
}
const Y = /^(\d{5})(\d{3})$/g, G = "$1-$2", ee = (e = "") => e.replace(Y, G), ze = (e = "") => ee(
  e.replace(/\D/g, "").replace(/(\d{5})(\d{1})/, "$1-$2").replace(/(\d{2})/, "$1")
), Re = (e, t) => {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}, te = /^(\d{1})(\d{2})$/g, ne = "$1,$2", re = (e = "") => e.replace(te, ne), Te = (e = "") => re(
  e.replace(/\D/g, "").replace(/(\d{1})(\d{1})/, "$1,$2").replace(/(\d{1})/, "$1")
), ce = /^(\d{3})(\d{1})$/g, oe = "$1,$2", se = (e = "") => e.replace(ce, oe), Pe = (e = "") => se(
  e.replace(/[^\d.,]/g, "").replace(/(\d{1,3})[.,]?(\d?)$/, "$1,$2").replace(/,$/, "")
), We = (e) => {
  const t = {
    a: "á|à|ã|â|ä|À|Á|Ã|Â|Ä",
    e: "é|è|ê|ë|É|È|Ê|Ë",
    i: "í|ì|î|ï|Í|Ì|Î|Ï",
    o: "ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö",
    u: "ú|ù|û|ü|Ú|Ù|Û|Ü",
    c: "ç|Ç",
    n: "ñ|Ñ"
  };
  return Object.keys(t).reduce((n, r) => n.replace(new RegExp(t[r], "g"), r), e.toLowerCase());
}, p = (e, t, n, r = !1) => {
  if (!(!r && t == null) && !(r && t === void 0)) {
    if (t instanceof Array) {
      t.forEach((c) => p(`${e}[]`, c, n));
      return;
    } else if (t instanceof File) {
      n.append(e, t);
      return;
    } else if (t instanceof Object) {
      Object.entries(t).forEach(([c, o]) => p(`${e}[${c}]`, o, n));
      return;
    }
    n.append(e, t);
  }
}, Ne = (e, t = !1) => {
  const n = new FormData();
  return Object.entries(e).forEach(([r, c]) => p(r, c, n, t)), n;
}, Xe = (e = "file", t) => {
  const r = `data:text/csv;charset=utf-8,\uFEFF${encodeURIComponent(t)}`, c = document.createElement("a");
  c.setAttribute("href", r), c.setAttribute("download", `${e}.csv`), document.body.appendChild(c), c.click();
}, Ue = (e = "file", t) => {
  const n = URL.createObjectURL(
    new Blob(
      [t],
      { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
    )
  ), r = document.createElement("a");
  r.href = n, r.setAttribute("download", `${e}.xlsx`), document.body.appendChild(r), r.click(), document.body.removeChild(r);
}, Le = (e = "file", t) => {
  const n = URL.createObjectURL(
    new Blob(
      [Buffer.from(t, "binary")],
      { type: "application/pdf" }
    )
  ), r = document.createElement("a");
  r.href = n, r.setAttribute("download", `${e}.pdf`), document.body.appendChild(r), r.click(), document.body.removeChild(r);
}, Ve = (e) => Number(e.replace(",", ".")), Be = (e) => (Object.keys(e).forEach((t) => !e[t] && (e[t] !== void 0 || e[t] !== "" || e[t] !== null) && delete e[t]), e), ae = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, He = (e) => ae.test(e), Ze = (e, t = 16) => {
  const n = e.length;
  let r = 5381;
  for (let o = 0; o < n; o++)
    r = r * 33 ^ e.charCodeAt(o);
  return (r >>> 0).toString(16).padStart(t, "0").slice(0, t);
};
export {
  h as checkIfIsAmex,
  d as compose,
  Ne as convertToFormData,
  $e as curriedObjectChange,
  Re as debounce,
  xe as deepSetter,
  Xe as exportCsv,
  Le as exportPdf,
  Ue as exportXlsx,
  _ as formatCnpj,
  j as formatCpf,
  z as formatCreditCard,
  ge as formatDate,
  X as formatExpirationDate,
  re as formatHeight,
  W as formatInputDate,
  U as formatInputMoney,
  ye as formatMoney,
  B as formatPhone,
  q as formatTime,
  se as formatWeight,
  ee as formatZipCode,
  Ae as getQueryParams,
  D as getUniqueValues,
  ie as head,
  _e as identity,
  de as maskCnpj,
  pe as maskCpf,
  me as maskCreditCard,
  De as maskDate,
  Ce as maskDuration,
  Ee as maskExpirationDate,
  Te as maskHeight,
  ke as maskMoney,
  Me as maskPhone,
  K as maskTime,
  Pe as maskWeight,
  ze as maskZipCode,
  We as normalizeString,
  he as pickTextColorBasedOnBgColor,
  ue as pureSplice,
  Be as removeEmptyAttribute,
  Ve as replaceCommaToDot,
  E as tail,
  ve as toCents,
  be as treatDurationMinutes,
  Se as unformatMoney,
  je as unmaskPhone,
  Ze as unsafeHash,
  le as validateCnpj,
  Fe as validateCpf,
  fe as validateCreditCard,
  He as validateEmailAddress,
  we as validateExpirationDate,
  b as validatePhone,
  Ie as validatePhoneWithDDI,
  Oe as validateTime
};
//# sourceMappingURL=bonitour-common-functions.es.js.map
